module.exports = __webpack_public_path__ + "img/Expo-Amy-Galper-Aromatherapy-Teaching-101.42f579f7.png";